import { createRoutine } from "../utils/routine.utils";
export var getRequirements = createRoutine("REQUIREMENTS_GET");
